import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Avatar, Box, Typography } from "@mui/material";
import RowMenu from "../common/RowMenu";

const EmployeeTable = ({ employees, onAction }) => {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
      <Table>
        <TableHead sx={{ bgcolor: '#fafafa' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>EMPLOYEE NAME</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>CATEGORY</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>EMAIL</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>PHONE</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {employees.map((row) => (
            <TableRow key={row.id} hover sx={{ opacity: row.isBlocked ? 0.6 : 1 }}>
              <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar sx={{ width: 32, height: 32, mr: 1, fontSize: '0.8rem' }}>{row.fullName?.[0]}</Avatar>
                      <Typography variant="body2">{row.fullName}</Typography>
                      {row.isBlocked && <Typography variant="caption" color="error" sx={{ ml: 1 }}>(Blocked)</Typography>}
                  </Box>
              </TableCell>
              <TableCell>{row.category}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.phone}</TableCell>
              <TableCell>
                <RowMenu 
                    actions={[
                        { label: 'View', onClick: () => onAction('view', row) },
                        { label: 'Edit', onClick: () => onAction('edit', row) },
                        { 
                            label: row.isBlocked ? 'Unblock' : 'Block', 
                            onClick: () => onAction(row.isBlocked ? 'unblock' : 'block', row),
                            color: row.isBlocked ? 'success.main' : 'error.main'
                        },
                        { label: 'Change Password', onClick: () => onAction('change-password', row) },
                        { label: 'Delete', onClick: () => onAction('delete', row), color: 'error.main' },
                    ]} 
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EmployeeTable;
